import React from "react";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import Slide from "@mui/material/Slide";
function SlideTransition(props) {
  return <Slide {...props} direction="up" />;
}

const Alert = React.forwardRef(function Alert(props, ref) {
  return (
    <MuiAlert
      elevation={6}
      ref={ref}
      variant="filled"
      {...props}
      icon={props.withIcon}
    />
  );
});
export default function Notify({
  open,
  setOpen,
  timing,
  errorType,
  withIcon = true,
  children,
}) {
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };
  return (
    <Snackbar
      open={open}
      autoHideDuration={timing}
      onClose={handleClose}
      TransitionComponent={SlideTransition}
      className="relative"
    >
      <Alert
        //onClose={handleClose}
        severity={errorType}
        sx={{ width: "100%" }}
        withIcon={withIcon}
      >
        {children}
      </Alert>
    </Snackbar>
  );
}
